import Lookup from 'src/componentes/select2';

const ConvenioLookup = ({ ...rest }) => (
  <Lookup
    labelKey="descricao"
    valueKey="id"
    url="/ConvenioLookup"
    clearable={true}
    {...rest}
  />
);

export default ConvenioLookup;
